import Home01Icon from "@hugeicons/core-free-icons/Home01Icon";
import PackageProcessIcon from "@hugeicons/core-free-icons/PackageProcessIcon";
import Invoice01Icon from "@hugeicons/core-free-icons/Invoice01Icon";
import RepeatIcon from "@hugeicons/core-free-icons/RepeatIcon";
import MoneyReceive01Icon from "@hugeicons/core-free-icons/MoneyReceive01Icon";
import Wallet01Icon from "@hugeicons/core-free-icons/Wallet01Icon";
import Clock01Icon from "@hugeicons/core-free-icons/Clock01Icon";
import UserMultipleIcon from "@hugeicons/core-free-icons/UserMultipleIcon";
import { SALES_ROLES } from "../constants/roles";

// Sales Console nav. Overview leads, matching src/v2/ops/nav-config.js and
// src/v2/pharmacy/nav-config.js -- all three consoles open on the same legacy /home
// charts, so the entry sits in the same place in all three sidebars.
export const SALES_NAV = [
    { key: "overview", label: "Overview", path: "/v2/sales/overview", icon: Home01Icon, roles: SALES_ROLES },
    { key: "reorders", label: "Reorders", path: "/v2/sales/reorders", icon: RepeatIcon, roles: SALES_ROLES },
    { key: "orders", label: "Orders", path: "/v2/sales/orders", icon: PackageProcessIcon, roles: SALES_ROLES },
    { key: "quotations", label: "Quotations", path: "/v2/sales/quotations", icon: Invoice01Icon, roles: SALES_ROLES },
    { key: "refunds", label: "Refunds", path: "/v2/sales/refunds", icon: MoneyReceive01Icon, roles: SALES_ROLES },
    { key: "outstanding", label: "Outstanding Amount", path: "/v2/sales/outstanding", icon: Wallet01Icon, roles: SALES_ROLES },
    { key: "tat", label: "TAT Dashboard", path: "/v2/sales/tat", icon: Clock01Icon, roles: SALES_ROLES },
    // Users — the legacy /users screen, reused as-is (see routes.jsx).
    { key: "users", label: "Users", path: "/v2/sales/users", icon: UserMultipleIcon, roles: SALES_ROLES },
];
